<p-toast [position]="position" (onClose)="onCloseMessage($event)">
    <ng-template let-message pTemplate="message">
        <div>
            <h3>{{message.summary}}</h3>
            <p class="detail">{{message.detail}}</p>
            <ul *ngIf="message.data?.list" class="toast-message-list">
                <li *ngFor="let item of message.data.list">{{item}}</li>
            </ul>
            <p *ngIf="message.data?.text" class="toast-message-text">
                {{message.data.text}}
            </p>
            <p *ngIf="message.data?.button">
                <button pButton (click)="message.data.button.action()">{{message.data.button.label}}</button>
            </p>
            <data *ngIf="message.data?._count && message.data?._count > 1"
                aria-label="Number of times this message has occurred" class="duplicate-message-occurrences"
                [value]="message.data._count">
                {{ message.data._count | number }} more messages like this
            </data>
        </div>
    </ng-template>
</p-toast>

<div class="p-toast p-component p-toast-center-center" *ngIf="authMessage"
    style="top: 50%; left: 50%; margin: -10rem 0 0 -6rem; z-index: 2000">
    <div class="p-toast-message p-toast-message-info">
        <div class="p-toast-message-content">
            <h3>{{authMessage.summary}}</h3>
            <p>{{authMessage.detail}}</p>
            <div style="text-align: center;">
                <i class="pi pi-spinner pi-spin"></i>
            </div>
        </div>
    </div>
</div>